import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    paddingBottom: 40,
    [theme.breakpoints.up('mobile')]: {
      paddingBottom: 0,
    },
  },
  title: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(4),
      fontSize: 24,
    },
  },
  text: {
    lineHeight: '21px',
    color: '#263238',
    [theme.breakpoints.up('mobile')]: {
      fontSize: 16,
      color: theme.palette.colors.black,
      lineHeight: '24px',
    },
  },
  formGroup: {
    margin: [theme.spacing(2), 0, 5],
    [theme.breakpoints.up('mobile')]: {
      margin: [theme.spacing(4), 0, theme.spacing(1)],
    },
  },
  field: {
    width: '100%',
    marginBottom: 11,
    '& fieldset': {
      borderColor: theme.palette.colors.border,
    },
    '& label': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      marginBottom: theme.spacing(1),
      color: '#90A4AE',
    },
    '& input': {
      height: '100%',
      padding: [0, 14],
    },
    [theme.breakpoints.up('mobile')]: {
      marginBottom: theme.spacing(3),
    },
  },
  button: {
    width: '100%',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      width: 156,
      marginTop: theme.spacing(1),
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerSettings/components/UpdatePasswordForm/useStyles.js